import ApplicationController from '../../frontend/support/application_controller'
import map from '../support/map.json'

export default class extends ApplicationController {

  static targets = [
    'tooltip'
  ]

  static values = {
    direction: String
  }

  connect() {}

  // ==== Controllers

  // ==== Actions

  move(event) {
    if (!this.hasTooltipTarget) return

    const mouseX = event.clientX
    const mouseY = event.clientY
    const popoverRect = this.tooltipTarget.getBoundingClientRect()
    const viewportWidth = window.visualViewport.width
    const viewportHeight = window.visualViewport.height

    let top = mouseY + parseInt(map.space_base_3x.original.value, 10)

    if (top + popoverRect.height > viewportHeight) {
      top = mouseY - popoverRect.height
    }

    let left = this.directionValue === 'left' ? mouseX : mouseX - popoverRect.width

    if (left < 0) {
      left = mouseX
    }

    if (left + popoverRect.width > viewportWidth) {
      left = viewportWidth - popoverRect.width
    }

    this.tooltipTarget.style.position = 'fixed'
    this.tooltipTarget.style.top = `${Math.max(0, top)}px`
    this.tooltipTarget.style.left = `${Math.max(0, left)}px`

    if (this.tooltipTarget.classList.contains('u-w-full')) {
      this.tooltipTarget.style.width = `${popoverRect.width}px`
    }
  }

  // ==== Getters

  // ==== Setters

  // ==== Private

  // ==== Channels

}
